export const NOTES_ACTION = 'Notes'
export const SIMILAR_TRACKS_ACTION = 'SimilarTracks'
export const TRACK_TRAY_ACTION = 'TrackTray'
export const FAVOURITES_ACTION = 'Favourites'
export const PROJECTS_ACTION = 'Projects'
export const DOWNLOAD_MP3_ACTION = 'Download-mp3'
export const CART_ACTION = 'Cart'
export const MORE_OPTIONS_ACTION = 'MoreOptions'
export const LICENSE_ACTION = 'License'
